/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MatchReadinessResponse } from './MatchReadinessResponse';
import {
    MatchReadinessResponseFromJSON,
    MatchReadinessResponseFromJSONTyped,
    MatchReadinessResponseToJSON,
    MatchReadinessResponseToJSONTyped,
} from './MatchReadinessResponse';

/**
 * 
 * @export
 * @interface UnreadyTeamResponse
 */
export interface UnreadyTeamResponse {
    /**
     * 
     * @type {MatchReadinessResponse}
     * @memberof UnreadyTeamResponse
     */
    readiness: MatchReadinessResponse;
}

/**
 * Check if a given object implements the UnreadyTeamResponse interface.
 */
export function instanceOfUnreadyTeamResponse(value: object): value is UnreadyTeamResponse {
    if (!('readiness' in value) || value['readiness'] === undefined) return false;
    return true;
}

export function UnreadyTeamResponseFromJSON(json: any): UnreadyTeamResponse {
    return UnreadyTeamResponseFromJSONTyped(json, false);
}

export function UnreadyTeamResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UnreadyTeamResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'readiness': MatchReadinessResponseFromJSON(json['readiness']),
    };
}

export function UnreadyTeamResponseToJSON(json: any): UnreadyTeamResponse {
    return UnreadyTeamResponseToJSONTyped(json, false);
}

export function UnreadyTeamResponseToJSONTyped(value?: UnreadyTeamResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'readiness': MatchReadinessResponseToJSON(value['readiness']),
    };
}

